const orgTypes = {
    third_party: 'Third Party',
    payer: 'Payer'
};
Object.freeze(orgTypes);
export default orgTypes;